import React from 'react';

export default React.createContext({
  showNotification: () => {},
  clearNotification: () => {},
  showSuccessNotification: () => {},
  showDangerNotification: () => {},
  showWarningNotification: () => {},
  showInfoNotification: () => {},
});
